let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("jKEvE")).then(() => parcelRequire('3RgGT'));